export const isNightShift = (startTime, endTime) => {
  if (!startTime || !endTime) return false;
  
  try {
    const [startHour] = startTime.split(':').map(Number);
    const [endHour] = endTime.split(':').map(Number);
    return endHour < startHour;
  } catch (e) {
    return false;
  }
};

export const getLoomEmbedUrl = (shareUrl) => {
  if (!shareUrl) return null;
  return shareUrl.replace('/share/', '/embed/');
};

export const formatWorkingHours = (start, end) => {
  if (!start || !end) return '09:00 - 17:00';
  
  const isNight = isNightShift(start, end);
  return `${start} - ${end} ${isNight ? '(overnight)' : ''}`;
};

export const formatWorkingDays = (days) => {
  if (!days || days.length === 0) return 'None';
  if (days.length === 7) return 'Every day';
  if (days.length === 5 && 
      days.includes('monday') && 
      days.includes('tuesday') && 
      days.includes('wednesday') && 
      days.includes('thursday') && 
      days.includes('friday')) {
    return 'Weekdays';
  }
  return days.map(day => day.slice(0, 3).toUpperCase()).join(', ');
};